import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function truncateText(text, maxLength = 100) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export function getStatusColor(status) {
  const colors = {
    'Active': 'bg-emerald-100 text-emerald-800',
    'Waiting': 'bg-amber-100 text-amber-800',
    'Closed': 'bg-zinc-100 text-zinc-800',
    'Pending': 'bg-amber-100 text-amber-800',
    'In Progress': 'bg-blue-100 text-blue-800',
    'Completed': 'bg-emerald-100 text-emerald-800',
    'Cancelled': 'bg-red-100 text-red-800',
    'Approved': 'bg-emerald-100 text-emerald-800',
    'Sent': 'bg-zinc-100 text-zinc-800',
    'Rejected': 'bg-red-100 text-red-800',
    'Draft': 'bg-zinc-100 text-zinc-800',
    'Reviewed': 'bg-blue-100 text-blue-800',
    'Applied': 'bg-emerald-100 text-emerald-800',
    'High': 'bg-red-100 text-red-800',
    'Medium': 'bg-amber-100 text-amber-800',
    'Low': 'bg-zinc-100 text-zinc-800',
  };
  return colors[status] || 'bg-zinc-100 text-zinc-800';
}
